import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CommandBus } from "../CommandBus";
import { RelayBuilder } from "./RelayBuilder";
export var CommandBusBuilder = /*#__PURE__*/function () {
  function CommandBusBuilder(source) {
    _classCallCheck(this, CommandBusBuilder);
    this.source = source;
    _defineProperty(this, "bus", void 0);
    this.bus = new CommandBus(source);
  }
  _createClass(CommandBusBuilder, [{
    key: "buildRelay",
    value: function buildRelay(name, builderCb) {
      var fullRelayName = "".concat(this.source, "-to-").concat(name);
      builderCb(new RelayBuilder(fullRelayName)).build().attachTo(this.bus);
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return this.bus;
    }
  }]);
  return CommandBusBuilder;
}();